import { Reducer } from "redux";

import { DocumentReviewResponse } from "../models/Api/Document";
import { DocumentDetailDispatchTypes } from "../models/DispatchTypes/Document";
import { DocumentDetailActionDispatchTypes } from "../constants/Document";

const initialState: DocumentReviewResponse = {
  loading: false,
  response: {
    id: 0,
    containsSupportedDoc: null,
    documentationDate: "",
    documentId: [],
    userCreated: null,
    type: 0,
    addedDocuments: [],
    referralFaxParameterId: 0,
  },
  error: null,
};

const SaveOrUpdateReferralDocument: Reducer<
  DocumentReviewResponse,
  DocumentDetailDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default SaveOrUpdateReferralDocument;
